import { render, staticRenderFns } from "./SelectSchema.vue?vue&type=template&id=238b2af5&scoped=true&"
import script from "./SelectSchema.vue?vue&type=script&lang=js&"
export * from "./SelectSchema.vue?vue&type=script&lang=js&"
import style0 from "./SelectSchema.vue?vue&type=style&index=0&id=238b2af5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238b2af5",
  null
  
)

export default component.exports